import { comparisonData } from "@/mocks/siteData";

export default function ComparisonTable() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-medium rounded-full mb-4">
            Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            BaseTao Spreadsheet vs Traditional Research
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            See how the spreadsheet approach transforms your shopping research experience.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-primary-700 whitespace-nowrap">
                  <div className="w-5 h-5 inline-flex items-center justify-center mr-1.5">
                    <i className="ri-file-list-3-line text-sm"></i>
                  </div>
                  BaseTao Spreadsheet
                </th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-600 whitespace-nowrap">
                  <div className="w-5 h-5 inline-flex items-center justify-center mr-1.5">
                    <i className="ri-edit-line text-sm"></i>
                  </div>
                  Traditional Research
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}>
                  <td className="px-6 py-4 font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-6 py-4 text-primary-700 font-medium">{row.basetao}</td>
                  <td className="px-6 py-4 text-foreground-500">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}